import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/pbxip/out');
  }
}

export default new Service();
